export const SERVICE = 'MODAL'
export const ADD_VENDOR_MODAL = 'ADD_VENDOR_MODAL'
export const OPEN_SAVE_NEW_SEARCH_MODAL = 'OPEN_SAVE_NEW_SEARCH_MODAL'
export const RESEND_INVITATION_MODAL = 'RESEND_INVITATION_MODAL'
